module.exports = __webpack_public_path__ + "img/badge-list-thumb-129.51e84000.png";